/// <amd-module name="Reporting/BoardsCommon/ReportPageState" />
import { BacklogsQuery } from "Analytics/Boards/BoardsQueries/BacklogsQuery";
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { getCurrentRoute } from "VSS/Platform/Navigation";
import { Uri } from "VSS/Platform/Util/Url";

export interface ReportState {
    categoryReferenceName: string;
    categoryName: string;
    teamId: string;
    teamName: string;
    projectId: string;
}
/** Best effort utility for getting report page parameters for New platform testing. Input handling is not hardened as robust under error scenarios.  */
export async function getReportPageState(pageContext: IVssPageContext): Promise<ReportState> {
    const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
    const projectInfo = await tfsPageService.getData()!.project;
    const teamInfo = await tfsPageService.getHorizontalNavigationTeamData();

    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const query = new BacklogsQuery(projectInfo!.id, [teamInfo!.id]);
    const backlogs = await queryCache.getCacheableQueryResult(query);
    const backlogName = extractParameter(pageContext, "backlogLevel");
    const matchingBacklogEntry = backlogs.findIndex(item => {
        return item.BoardName === backlogName && item.IsBoardVisible;
    });

    return {
        teamId: teamInfo!.id,
        teamName: teamInfo!.name,
        projectId: projectInfo!.id,
        categoryReferenceName: (matchingBacklogEntry >= 0 && backlogs[matchingBacklogEntry].BoardCategoryReferenceName) || "",
        categoryName: backlogName!
    };
}

export function extractParameter(pageContext: IVssPageContext, paramName: string): string | undefined | null {
    const routeValues = getCurrentRoute(pageContext).routeValues;
    return routeValues[paramName] !== undefined ? routeValues.backlogLevel : new Uri(window.location.href).getQueryParam(paramName);
}
